module.exports = __webpack_public_path__ + "img/setting-map-location-icon.c519e0ca.svg";